import React from 'react'
import { connect } from 'react-redux'
import MarkdownWrapper from '../../utils/markdown-wrapper'

const ResourceSummary = ({ selectedFilter, filterObjects }) => {
    const renderSummary = () => {
        const filter = filterObjects.find(f => f.name === selectedFilter)
        const { color, name, description } = filter

        if (!filter) {
            return null
        }

        return (
            <div className={`resource-summary ${color || ''}-bg`}>
                <div className="category">
                    {name}
                </div>
                <div className="content">
                    <MarkdownWrapper content={description || ''} />
                </div>
            </div>
        )
    }

    return renderSummary()
}

export default connect()(ResourceSummary)
